import { loadState } from '@/store'
import { identifyUserInLaunchDarkly } from '@/services/launchDarkly'
import startAsyncService from '@/services/retry-service'
import { identifyUserInTracking } from '@/services/tracking'

const LAUNCH_DARKLY_SERVICE_NAME = 'Launch Darkly'

export const loadUserData = async (onLogin = false) => {
  if (!(await loadState())) {
    return
  }

  startAsyncService(LAUNCH_DARKLY_SERVICE_NAME, identifyUserInLaunchDarkly)

  identifyUserInTracking(onLogin)
}
